export default __webpack_public_path__ + "assets/aa6914e198fa8a8b00c9e1b2a6f9c83b.jpeg";